// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3sikK","select":"Header_select__3wXv-","clinic":"Header_clinic__1nUQB"};